import { ApolloError } from '@apollo/client';
import { ERROR_CODES } from '@shinetools/errors';

import { TeamMemberRole } from '__generated__/GQL';
import {
  EDITABLE_ROLES,
  EditableRole,
} from 'features/Team/components/MemberInformationRoleForm/schema';

import locales from './locales';

export const getLocalizedError = (error: unknown): string => {
  if (error instanceof ApolloError) {
    const graphqlErrorMessage = error.graphQLErrors[0]?.extensions.code;
    if (
      graphqlErrorMessage === ERROR_CODES.COMPANY_INVITATION_QUOTA_LIMIT_REACHED
    ) {
      return locales.errors[
        ERROR_CODES.COMPANY_INVITATION_QUOTA_LIMIT_REACHED
      ] as string;
    } else if (graphqlErrorMessage === ERROR_CODES.EMAIL_ALREADY_EXISTS) {
      return locales.errors[ERROR_CODES.EMAIL_ALREADY_EXISTS] as string;
    }
  }
  return locales.errors.invitationError;
};

const RoleGrade: Record<EditableRole, number> = {
  ACCOUNTANT: 1,
  ADMIN: 3,
  EMPLOYEE: 2,
};

export const getBestEditableRole = (
  roles: TeamMemberRole[],
): EditableRole | null =>
  roles
    .filter((role): role is EditableRole =>
      EDITABLE_ROLES.includes(role as EditableRole),
    )
    .reduce<[number, EditableRole | null]>(
      ([bestGrade, bestRole], role) => {
        if (RoleGrade[role] > bestGrade) {
          return [RoleGrade[role], role];
        }
        return [bestGrade, bestRole];
      },
      [0, null],
    )[1];
